import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListAdminUserResponse } from '../../responses/admin-user/list-admin-user.response';

@Injectable({
  providedIn: 'root'
})
export class ListUserService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }
  
  public listAdminUser(): Observable<ListAdminUserResponse> {
    
    let uri = 'listUser'
    
    return this.httpClient.get<ListAdminUserResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }

  public listAdminUserByIds(ids:number[]): Observable<ListAdminUserResponse> {
    
    let uri = `listUser/ByIds?ids=[${ids}]`;
    
    return this.httpClient.get<ListAdminUserResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}
    